import { Menu } from "antd";

const VerticleMenuContent = (props) => {
    return (
        <div className="flex size-full flex-1 gap-4 overflow-auto">
            <div className="scroll-webkit relative flex h-full min-w-[250px] flex-none flex-col overflow-auto border-r border-r-gray-100">
                <Menu style={{ border: 0 }} onSelect={({ key }) => props.onItemClick(key)} mode="vertical" selectedKeys={[props.activeItem]}>
                    {props.items.map((item) => {
                        return (
                            <Menu.Item key={item.name} data-testid={`vertical-menu-configuration-${item.name}`}>
                                {item.description}
                            </Menu.Item>
                        );
                    })}
                </Menu>
            </div>
            <div className="scroll-webkit flex size-full flex-1 flex-col overflow-auto p-2">
                <div className="relative size-full flex-1">{props.itemContainer}</div>
            </div>
        </div>
    );
};

export default VerticleMenuContent;
